// extracted by mini-css-extract-plugin
export var externalLink = "_7x-0";
export var internalLinkLabel = "_7x-1";